<template>
  <b-container class="mt-5 bopmodel-site-configuration">
    <h1>{{ $t("bopAccess.title") }}</h1>
    <b-card class="default">
      <b-row>
        <b-col md="6">
          <b-form-group
            id="site-group"
            :label="$t('bopAccess.selectSite.label')"
            label-for="site-ddl"
          >
            <b-form-select
              id="site-ddl"
              v-model="selectedSite"
              @change="checkDeployedBopModel"
              :options="sites"
              value-field="site"
              text-field="translation.name"
            >

              <template #first>
                <b-form-select-option :value="null" disabled>{{
                  $t("bopAccess.selectSite.defaultMessage")
                }}</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
          
        </b-col>
      <div class="mt-3">
        <b-button variant="primary" :disabled="selectedRows.length === 0" @click="save">{{ $t('bopAccess.save') }}</b-button>
      </div>
      </b-row>
    </b-card>
    <div v-show="selectedSite !== null">
      <DataTable
        ref="table"
        :columns="dtColumns"
        :url="url"
        trackBy="bopModel.id"
        :searchable="false"
        :parseResponse="parseResponse"
        :showActions="false"
      >
        <template #checkbox="{ row }">
          <input
            type="checkbox"
            :checked="isRowChecked(row)"
            @change="onCheckboxChange(row)"
          />
        </template>
        <template #nameCell="{ row }">
          <span>{{ row.translation?.name }}</span>
        </template>
      </DataTable>

    </div>
  </b-container>
</template>

<script lang="ts">
import BopModelService from "@/services/BopModelService";
import SitesServices from "@/services/SitesServices";
import Constants from "@/utils/Constants";
import { Component,Vue,Watch } from "vue-property-decorator";
type Data = {
  columns: Array<Object>;
  rows: Array<Object>;
};

@Component({
  components: {
    DataTable: () => import("@/components/Shared/Table/DataTable.vue"),
  },
})
export default class BopModelsSiteConfiguration extends Vue {
  public data: Data = {
    columns: [
      { name: "checkbox", title: "", property: "bopModel.id" },
      {
        name: "editable",
        sortField: "translation.name",
        title: this.$t("bopAccess.bopModelName"),
        property: "translation.name",
        isNotEditable: true,
      },
    ],
    rows: [],
  };

  public sites: Array<any> = [];
  public selectedRows: Array<string> = [];
  public checkedRows: Array<string> = [];
  public selectedSite: any = null;
  private url: string = BopModelService.getTableUrl(this.$i18n.locale);
  private parseResponse(resp:any) {
    const data = resp?.data || [];
    const rows = Array.isArray(data)? data : (Array.isArray(data?.data)? data.data : []);
    return { rows, pagination: resp?.pagination };
  }
  private get dtColumns(): Array<{ key:string; label:string; sortField?:string; slot?:string }> {
    return [
      { key:'checkbox', label:'', slot:'checkbox' },
      { key:'name', label: this.$t('bopAccess.bopModelName').toString(), sortField:'translation.name', slot:'nameCell' },
    ];
  }
  private getRowId(row:any): string {
    return row?.bopModel?.id;
  }
  private isRowChecked(row:any): boolean {
    const id = this.getRowId(row);
    return !!id && this.checkedRows.includes(id);
  }
  private onCheckboxChange(row:any) {
    const id = this.getRowId(row);
    if (!id) return;
    const idxChecked = this.checkedRows.indexOf(id);
    if (idxChecked === -1) this.checkedRows.push(id);
    else this.checkedRows.splice(idxChecked,1);

    const idxSelected = this.selectedRows.indexOf(id);
    if (idxSelected === -1) this.selectedRows.push(id);
    else this.selectedRows.splice(idxSelected,1);
  }
  public async save() {
    try {
      let response = await SitesServices.DeployBopModels(
        this.selectedSite.id,
        this.checkedRows
      );
      if (response.status === 200) {
        this.refresh();
        this.selectedRows = [];
        this.$notify({
          group: "global",
          type: "success",
          title: this.$t("bopAccess.saveSucessMessageTitle").toString(),
          text: this.$t("bopAccess.saveSucessMessageBody").toString(),
        });
      }
    } catch {
      this.$notify({
        group: "globalError",
        type: "error",
        title: this.$t("bopAccess.saveErrorMessageTitle").toString(),
        text: this.$t("bopAccess.saveErrorMessageBody").toString(),
        duration: Constants.DEFAULT_WAIT_ERROR_NOTIFICATIONS,
      });
    }
  }
  public refresh() {
    let siteResult: any = {};
    SitesServices.getTranslatedSite(
      this.selectedSite.id,
      this.$i18n.locale
    ).then((response: any) => {
      siteResult = response.data.site;
      let index: number = this.sites.findIndex(
        (s: any) => s.site.id === this.selectedSite.id
      );
      this.sites[index].site = siteResult;
      this.selectedSite = this.sites[index].site;
      this.$store.commit("changeHasBeenModified", false);

    });

    const table:any = this.$refs.table; if (table && table.api && this.url) table.api.load(this.url);
  }

  // rowsSelectionChange no longer used; selection handled via checkbox slot

  /**
   * Check the deployed bopmodels in the selected site
   */
  public async checkDeployedBopModel() {
    this.$store.commit('changeIsFirstCheckBoxTableLoad',true);
    this.checkedRows = (await BopModelService.getDeployedBySite(this.selectedSite.id)).data;
    
  }
  private async loadElements() {
    const response = await SitesServices.getEnabledSites(this.$i18n.locale);
    if (response.status === 200) {
      this.sites = response.data;
    }
  }
  public mounted() {
    this.loadElements();
  }
  @Watch("$i18n.locale")
  private onLocaleChange() {
    this.url = BopModelService.getTableUrl(this.$i18n.locale);
    this.loadElements();
    this.$store.commit("changeHasBeenModified", false);
  }
}
</script>
<style lang="scss" scoped>

</style>
